import HomeIcon from "@mui/icons-material/Home";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EarbudsIcon from "@mui/icons-material/Earbuds";
import TableChartIcon from "@mui/icons-material/TableChart";
import TimelineIcon from "@mui/icons-material/Timeline";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import CycloneIcon from "@mui/icons-material/Cyclone";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import LeftArrow from "@mui/icons-material/ChevronLeft";
import RightArrow from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveIcon from "@mui/icons-material/Remove";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ListIcon from "@mui/icons-material/List";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import ChangePassword from "@mui/icons-material/Https";
import {
  ShrinkOutlined,
  EditOutlined,
  DownOutlined,
  RightOutlined,
  PlusOutlined,
  ClockCircleOutlined,
  UserOutlined,
  MessageFilled,
  LinkOutlined,
} from "@ant-design/icons";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageIcon from "@mui/icons-material/Image";
import ErrorIcon from "@mui/icons-material/Error";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WestIcon from "@mui/icons-material/West";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import SendIcon from "@mui/icons-material/Send";
import FormatListBulletedTwoToneIcon from "@mui/icons-material/FormatListBulletedTwoTone";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import AddCommentIcon from "@mui/icons-material/AddComment";
import LoopIcon from "@mui/icons-material/Loop";
import MapsUgcIcon from "@mui/icons-material/MapsUgc";
import { Spin } from "antd";
import SearchIcon from "@mui/icons-material/Search";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import High from "@mui/icons-material/ArrowUpward";
import Low from "@mui/icons-material/Remove";
import Normal from "@mui/icons-material/ExpandLess";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import FormatColorFillIcon from "@mui/icons-material/FormatColorFill";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LinkIcon from "@mui/icons-material/Link";
import SettingsIcon from "@mui/icons-material/Settings";
import WarningIcon from "@mui/icons-material/WarningAmber";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import FolderIcon from "@mui/icons-material/Folder";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import AddressBook from "@mui/icons-material/PermContactCalendar";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InfoIcon from "@mui/icons-material/Info";
import AdjustIcon from "@mui/icons-material/Adjust";
import CheckIcon from "@mui/icons-material/Check";
import EmailIcon from "@mui/icons-material/Email";
import DownloadIcon from "@mui/icons-material/Download";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import TagIcon from "@mui/icons-material/Tag";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PrintIcon from "@mui/icons-material/Print";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import DoneIcon from "@mui/icons-material/Done";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import VideocamIcon from "@mui/icons-material/Videocam";
import CopyIcon from "@mui/icons-material/ContentCopy";
import RefreshIcon from "@mui/icons-material/Refresh";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
const InnoIcons = {
  HomeIcon,
  InboxIcon,
  MailIcon,
  DashboardIcon,
  AnalyticsIcon,
  CallSplitIcon,
  PersonAddIcon,
  KeyboardArrowDownIcon,
  AccountBoxIcon,
  AccountBalanceIcon,
  LogoutIcon,
  NotificationsIcon,
  EarbudsIcon,
  TableChartIcon,
  TimelineIcon,
  FormatAlignLeftIcon,
  AllInclusiveIcon,
  CycloneIcon,
  AppRegistrationIcon,
  LeftArrow,
  RightArrow,
  AddIcon,
  AddCircleRoundedIcon,
  AccountBoxRoundedIcon,
  EditIcon,
  SaveIcon,
  CancelIcon,
  DeleteIcon,
  ShrinkOutlined,
  EditOutlined,
  DownOutlined,
  RightOutlined,
  PlusOutlined,
  RemoveIcon,
  CalendarMonthIcon,
  ClockCircleOutlined,
  UserOutlined,
  ListIcon,
  SpaceDashboardIcon,
  InsertDriveFileIcon,
  ImageIcon,
  ErrorIcon,
  KeyboardArrowRightIcon,
  MoreVertIcon,
  BackupTableIcon,
  CloseIcon,
  CheckCircleIcon,
  WestIcon,
  CloudUploadOutlinedIcon,
  SendIcon,
  FormatListBulletedTwoToneIcon,
  ModeCommentIcon,
  AddCommentIcon,
  LoopIcon,
  MessageFilled,
  MapsUgcIcon,
  Spin,
  SearchIcon,
  TrendingUpIcon,
  ArrowDropDown,
  High,
  Normal,
  Low,
  AddCircleOutlineIcon,
  PersonRoundedIcon,
  FormatColorFillIcon,
  ManageAccountsIcon,
  LinkIcon,
  FormatColorFillIcon,
  SettingsIcon,
  ChangePassword,
  WarningIcon,
  VisibilityIcon,
  VisibilityOffIcon,
  ArrowBackIcon,
  LockIcon,
  LockOpenIcon,
  ArrowDropUpIcon,
  ArrowDropDownIcon,
  SwapVertIcon,
  FolderIcon,
  PhotoLibraryIcon,
  AddressBook,
  MenuIcon,
  ArrowForwardIosIcon,
  InfoIcon,
  AdjustIcon,
  CheckIcon,
  EmailIcon,
  DownloadIcon,
  ShoppingCartIcon,
  RemoveShoppingCartIcon,
  GppMaybeIcon,
  SupportAgentIcon,
  FolderOutlinedIcon,
  DescriptionOutlinedIcon,
  AutoStoriesOutlinedIcon,
  EditOutlinedIcon,
  DeleteOutlineOutlinedIcon,
  FileDownloadOutlinedIcon,
  MoreVertOutlinedIcon,
  ShoppingCartOutlinedIcon,
  MenuBookOutlinedIcon,
  InfoOutlinedIcon,
  HomeOutlinedIcon,
  LanguageRoundedIcon,
  KeyboardDoubleArrowRightIcon,
  LinkOutlined,
  CreateNewFolderOutlinedIcon,
  PhoneIcon,
  LocationOnIcon,
  SquareFootIcon,
  TagIcon,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
  PrintIcon,
  AutoAwesomeIcon,
  ArrowBackIosNewIcon,
  KeyboardDoubleArrowLeftIcon,
  DoneIcon,
  AddPhotoAlternateIcon,
  VideocamIcon,
  CopyIcon,
  RefreshIcon,
  FolderZipIcon,
  VideoLibraryIcon,
};

export default InnoIcons;
